import { get as lodashGet } from "lodash-es";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";

// This toggle is only for development purposes, will be removed when we release the new global search
export const useEnableGlobalSearchNext = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "custom_ui_labels.specialFeatures", [""]).includes(
    "ENABLE_NEW_GLOBAL_SEARCH"
  );
};
